// PaywallHeader.tsx
// Reusable header with close button for all paywall steps

import React from 'react';
import { View, Pressable, StyleSheet } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import Ionicons from '@expo/vector-icons/Ionicons';
import { Theme } from '../../../utils/theme';

interface PaywallHeaderProps {
  onClose: () => void;
}

export const PaywallHeader: React.FC<PaywallHeaderProps> = ({ onClose }) => {
  const insets = useSafeAreaInsets();

  return (
    <View style={[styles.container, { paddingTop: Math.max(insets.top, Theme.spacing.md) }]}>
      <Pressable
        onPress={onClose}
        style={styles.closeButton}
        hitSlop={{ top: 16, right: 16, bottom: 16, left: 16 }}
        accessibilityLabel="Close paywall"
      >
        <Ionicons name="close" size={24} color={Theme.colors.textPrimary} />
      </Pressable>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 10,
    paddingHorizontal: Theme.spacing.lg,
  },
  closeButton: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: Theme.colors.surface,
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'flex-start',
    ...Theme.shadows.sm,
  },
});

